import * as React from 'react';
import PropTypes from "prop-types";
import {isNil, isNull} from "lodash";
import CreatableSelect from "react-select/creatable";
import {useTranslation} from "react-i18next";
import useAfterUpdateEffect from "../../utils/useAfterUpdateEffect";

function PaymentDaysSelect(props) {
  const { t } = useTranslation('payment_days_select')
  const [value, setValue] = React.useState(isNil(props.value) ? null : props?.value);

  useAfterUpdateEffect(() => {
    if(!isNil(props.value)){
      setValue(props.value)
    }
  }, [props.value])

  const daysOptions = [0, 3, 7, 14, 30, 60];
  const options = daysOptions.map(days => ({ label: t('days', {count: days}), value: days }));

  return <CreatableSelect
    classNamePrefix="react-select"
    className="w-100"
    value={!isNull(value) ? {
      label: t('days', {count: value}),
      value: value,
    } : null}
    options={options}
    createOptionPosition={"first"}
    formatCreateLabel={(value) => t('days', {count: value})}
    onChange={option => {
      const newValue = option?.value ?? null;
      setValue(newValue);
      props.onChange(newValue);
    }}
    isClearable={props.isClearable}
    placeholder={t('placeholder')}
  />}

PaymentDaysSelect.propTypes = {
  datePayment: PropTypes.string,
  date: PropTypes.string,
  value: PropTypes.number,
  clientDefault: PropTypes.bool,
  isClearable: PropTypes.bool,
};

PaymentDaysSelect.defaultProps = {
  isClearable: false,
};

export default PaymentDaysSelect;
